export default {
  memberCommand: {
    "services": "Services",
    "diagnostics": "Diagnostics des développeurs",
    "placeholder": "Trouvez une page ou une action...",
    "club": "VOTRE CLUB",
    "quick": "ACTIONS QUICK",
    "current": "Actuel",
    "navigate": "Navigation",
    "open": "Ouvrir",
    "close": "Fermer",
    "empty": "Pas de pages ou d'actions correspondantes. Essayez une autre recherche.",
    "clear": "Effacer la recherche",
    "label": "Membres navigation",
    "results": "Résultats disponibles : {count}",
    "bookings": "Mes réservations",
    "account": "Mon compte",
    "other": "Portail des Membres",
    "dashboard": "Votre club en un coup d'oeil",
    "book-facilities": "Golf, raquettes, repas et plus",
    "activities": "Découvrez les façons de profiter de votre club",
    "academy": "Camps, programmes et ateliers",
    "events": "Que se passe-t-il à votre club",
    "reciprocal-clubs": "Explorez votre réseau réciproque",
    "accommodations": "Trouvez et réservez votre prochain séjour",
    "manage": "Gérez vos activités",
    "voting": "Voir les motions du club et voter",
    "dashboardKeywords": "Aperçu général de la maison",
    "book-facilitiesKeywords": "réservations salle de restaurant de sport",
    "activitiesKeywords": "clubs loisirs",
    "academyKeywords": "cours d ' apprentissage",
    "eventsKeywords": "billets de calendrier",
    "reciprocal-clubsKeywords": "partenaires Accès aux voyages",
    "accommodationsKeywords": "chambres d'hôtel séjours",
    "manageKeywords": "Activités administratives",
    "votingKeywords": "bulletins de vote"
},
  member_all_handicaps: "Tous les handicaps",
  member_handicap_or_better: "Handicap {value} ou mieux",
  member_handicap_or_worse: "Handicap {value} ou pire",

  member_leave: "Partez.",
  member_unable_to_leave_this_open_group_right_now: "Incapable de quitter ce groupe ouvert maintenant.",
  member_leave_group_confirm: "Laissez ce groupe ouvert ?",
  member_hosts_manage_booking: "Gérez votre réservation à partir des prochaines réservations.",
  member_loading_open_groups: "Chargement des groupes ouverts...",
  member_open_groups: "Groupes ouverts",
  member_open_group_help: "Invitez d'autres membres à remplir les lieux que vous choisissez. Votre réservation reste privée à moins que vous ne sélectionnez Open group.",
  member_level_not_provided: "Niveau non fourni",
  member_level_metric: "Niveau",
  member_handicap_metric: "Handicap",
  member_all_levels: "Tous niveaux",
  member_level_preferences: "Gamme de niveaux privilégiés",
  member_level_preferences_help: "Facultatif · échelle de profil 1–5. Laisser les deux blancs pour tous les niveaux. Ceci est une préférence.",
  member_minimum_level: "Niveau minimum",
  member_maximum_level: "Niveau maximal",
  member_open_groups_load_failed: "Impossible de charger des groupes ouverts.",
  member_open_group_details_failed: "Incapable de charger les détails du groupe.",

  member_events_retry: "Réessayer",
  "member_events_heading": "Évènements",
  "member_event_count_one": "Événements : {count}",
  "member_event_count_other": "Événements : {count}",
  "at_risk": "Risque",
  "super_engaged": "Super fiancé",
  "proactive_exposure_recovery_opportunities": "Exposition proactive et possibilités de rétablissement",
  "outstanding": "Impayé",
  "cancellations": "Annulations",
  "disengagement": "Désengagement",
  "membership_spend_ytd": "Dépenses d'adhésion · YTD",
  "total_members": "Total des membres",
  "new_members": "Nouveaux membres",
  "this_month": "Ce mois-ci",
  "amount_due": "Montant dû",
  "member_accounts": "Comptes créditeurs",
  "find_a_member": "Trouver un membre",
  "search_members": "Membres de recherche",
  "hidden_patterns_across_your_club": "Des modèles cachés dans votre club",
  "no_current_intelligence_items": "Aucun renseignement actuel.",
  "no_upcoming_birthdays": "Aucun anniversaire à venir",
  "nothing_in_the_current_period": "Rien dans la période actuelle",
  "club_conditions_and_forecast": "Conditions du club et prévisions",
  "view_current_conditions": "Voir les conditions actuelles",
  "open_the_live_club_forecast": "Ouvrir la prévision du club en direct",
  "unable_to_load_this_dashboard_data_right_now": "Impossible de charger ces données de tableau de bord en ce moment.",
  "loading_exposure_detail": "Chargement des détails d'exposition...",
  "outstanding_balances": "Soldes non réglés",
  "cancellations_refunds": "Annulations et remboursements",
  "disengagement_exposure": "Exposition au désengagement",
  "total_exposure": "Exposition totale",
  "record": "Enregistre",
  "no_records_in_this_category": "Pas d'enregistrement dans cette catégorie.",
  "loading_metrics": "Chargement des métriques...",
  "unable_to_load_leadership_metrics": "Incapable de charger des métriques de direction.",
  "executive_snapshot_year_to_date": "Capture d'écran de direction · Année à ce jour",
  "membership_spend": "Dépenses d ' affiliation",
  "net_movement_this_month": "Mouvement net ce mois-ci",
  "member_account_exposure": "Exposition au compte des membres",
  "membership_health": "Santé des membres",
  "revenue_exposure_composition": "Répartition des recettes",
  "needs_attention": "Besoin d ' attention",
  "outstanding_member_account_balances_require_review": "Les soldes des comptes des membres sortants doivent être examinés.",
  "loading_intelligence": "Chargement de l'intelligence...",
  "dashboard_details": "Détails du tableau de bord",
  "favourites": "Préférés",
  "new_chat": "Nouveau chat",
  "collapse_panel": "Panneau d ' effondrement",
  "show_history": "Histoire",
  "loading_conversation": "Chargement de conversation...",
  "conversation_could_not_be_restored": "La conversation ne peut être rétablie",
  "retry_loading": "Charge de l ' entrée",
  "how_can_i_help_you_manage_the_club_today": "Comment puis-je vous aider à gérer le club aujourd'hui ?",
  "external_sources": "Sources extérieures",
  "sources": "Sources",
  "prepare_again": "Préparez-vous à nouveau.",
  "sms_option": "Option sMS",
  "no_message_preview_available": "Pas de prévisualisation de message disponible.",
  "sent": "Envoyé",
  "member_option": "Option Membre",
  "select": "Sélectionner",
  "review_proposed_action": "Examen des mesures proposées",
  "review_draft": "Projet de révision",
  "review_action": "Examen de la question",
  "staff_member": "Membre du personnel",
  "email_draft": "Projet de projet de résolution",
  "select_one_of_your_mailboxes": "Sélectionnez une de vos boîtes aux lettres",
  "connect_your_mailbox_to_prepare_mailbox_backed_drafts_later": "Connectez votre boîte aux lettres pour préparer les ébauches de boîte aux lettres plus tard",
  "recipients": "Bénéficiaires",
  "no_recipients_selected_editable_unsent_draft": "Aucun récipiendaire sélectionné · éditable, insent draft",
  "recipient_contact_details_need_attention_this_draft_remains_saved_and_unsent": "Les coordonnées du bénéficiaire ont besoin d'attention. Ce projet reste sauvegardé et insent.",
  "recipients_individual_emails": "destinataires · courriels individuels",
  "missing_email": "courriel manquant",
  "subject": "Sujet",
  "email_subject": "Sujet de courrier électronique",
  "email_cc": "Courriel CC",
  "email_bcc": "E-mail en Cci",
  "sender_mailbox": "Boîte aux lettres de l'expéditeur",
  "server_selected_mailbox": "Boîte de courrier choisie par le serveur",
  "email_body": "Corps de messagerie",
  "preview_personalised_email": "Prévisualiser les courriels personnalisés",
  "first_name_is_personalised_for_each_recipient": "Le prénom est personnalisé pour chaque destinataire.",
  "preview_recipient": "Aperçu destinataire",
  "previewing_as": "Prévisualisation comme",
  "recipient": "bénéficiaire",
  "your_saved_signature": "Votre signature sauvegardée",
  "connect_mailbox": "Connecter la boîte aux lettres",
  "discard": "Renonciation",
  "reload_draft": "Recharger le brouillon",
  "action_failed": "Action échouée",
  "an_unknown_error_occurred": "Une erreur inconnue s'est produite.",
  "golf_outing_created": "Sortie de golf créée !",
  "view_in_events": "Vue sur les événements",
  "view_tee_sheet": "Voir la fiche Tee",
  "action_successful": "Action Successive",
  "stopping": "Arrête...",
  "preparing_your_answer": "Préparer votre réponse.",
  "confirm_send": "Confirmez l'envoi",
  "target": "Cible :",
  "confirming": "Confirmation…",
  "privana_assist_is_working": "Privana Assist fonctionne...",
  "answer_now_becomes_available_after_verified_work_completes": "La réponse devient maintenant disponible après que le travail vérifié se termine.",
  "answer_now": "Réponds maintenant.",
  "unable_to_continue": "Incapable de continuer",
  "completed_evidence_and_outputs_were_retained": "Des éléments de preuve et des extrants ont été conservés.",
  "completed_verified_work_was_retained_you_can_retry_when_the_reported_constraint_is_resolved": "Les travaux vérifiés ont été conservés. Vous pouvez réessayer lorsque la contrainte signalée est résolue.",
  "jump_to_latest": "Saut à la dernière",
  "retry_loading_this_conversation_before_sending": "Retry charge cette conversation avant d'envoyer.",
  "finish_cancel_or_answer_the_current_request_before_starting_another": "Terminer, annuler ou répondre à la demande actuelle avant de commencer une autre.",
  "ask_privana_e_g_add_a_new_member_named_john_smith": "Demandez Privana ... (par exemple, 'ajouter un nouveau membre nommé John Smith')",
  "send_message": "Message",
  "conversation_loading_failed_retry_is_required_before_you_can_send": "Le chargement de conversation a échoué. Retry est nécessaire avant que vous puissiez envoyer.",
  "explore": "Explorez",
  "shift_enter_for_newline": "Shift+Enter pour la nouvelle ligne",
  "edit_sms_option": "Modifier SMS (Option)",
  "upcomingOne": "Anniversaires à venir : {count}",
  "upcomingMany": "Anniversaires à venir : {count}",
  "inDaysOne": "Délai en jours : {count}",
  "inDaysMany": "Délai en jours : {count}",
  "atRiskOne": "Membres actuellement classés à risque : {count}.",
  "atRiskMany": "Membres actuellement classés à risque : {count}.",
  "confidence": "Confiance",
  "confidenceHigh": "Élevé",
  "confidenceMedium": "Moyen",
  "confidenceLow": "Faible",
  "confidenceCurrent": "Actuel",
  "nextStep": "Prochaine étape: {action}",
  "highLow": "H: {high} ° L: {low} °",
  "precipitation": "Chance de précipitation",
  "keypadKey": "Cadran {key}",
  "starKey": "étoile",
  "hashKey": "hash",
  "deleteDigit": "Supprimer le dernier chiffre",
  "favouriteChat": "Conversation préférée",
  "unfavouriteChat": "Retirer la conversation des favoris",
  "deleteChat": "Supprimer la conversation",
  "emptyHistory": "Pas encore de conversations.",
  "emptyFavourites": "Pas encore de conversations préférées.",
  "patterns": {
    "department_exposure_concentration": {
      "headline": "Le risque de revenu est concentré dans {department}",
      "evidence": "{percent} % de l'exposition actuelle est liée à {department} .",
      "implication": "Une balançoire dans ce ministère pourrait toucher rapidement de l'argent. Assigner un propriétaire à examiner les principales créances et les pilotes d'annulation dans {department} cette semaine.",
      "actionLabel": "Examen de la dépendance {department}"
    },
    "outstanding_balance_department_concentration": {
      "headline": "La plupart des soldes restants sont liés à {department}",
      "evidence": "{percent} % des soldes ouverts sont à partir de {department}.",
      "implication": "L'impact des recouvrements est probablement le plus élevé dans {department} ; prioriser cette file devrait accélérer la récupération de trésorerie.",
      "actionLabel": "Priorité {department} collections"
    },
    "cancellation_day_of_week_spike": {
      "headline": "Les annulations sont groupées sur {day} s",
      "evidence": "{percent} % des annulations des 90 derniers jours se sont produites sur {day} (environ {ratio} x autres jours de semaine).",
      "implication": "Ceci indique généralement un service de jour ou de frottement de planification. Examen {day} de la dotation, des fenêtres de réservation et des raisons d'annulation.",
      "actionLabel": "Audit {day} flux de réservation"
    },
    "disengagement_department_overlap": {
      "headline": "Les membres à risque sont surindexés dans {department}",
      "evidence": "{percent} % des membres à faible risque d'engagement ont une carte de {department} modèles d'activité.",
      "implication": "Une campagne de réengagement ciblée en {department} pourrait réduire les fuites de revenus futures.",
      "actionLabel": "Lancement {department}"
    },
    "revenue_vs_activity_divergence": {
      "headline": "Le revenu augmente plus vite que l'activité des membres",
      "evidence": "Le revenu est en hausse de {revenueChange} % sur 30 jours alors que l'activité transactionnelle est de {activityChange} %.",
      "implication": "La croissance des revenus peut provenir du prix/mélange au lieu d'une participation plus large. Vérifiez quels ministères et les cohortes membres transportent l'ascenseur.",
      "actionLabel": "Valider la qualité de croissance par segment"
    },
    "receivables_cluster_by_department": {
      "headline": "Les créances plus anciennes sont concentrées en {department}",
      "evidence": "{percent} % des soldes de 60 jours sont en {department} .",
      "implication": "La traînée semble concentrée. Une stratégie de vieillissement ciblée dans {department} devrait améliorer les récupérations.",
      "actionLabel": "Concentrez-vous sur 60+ journée de sensibilisation en {department}"
    },
    "rising_risk_falling_usage": {
      "headline": "Le risque des membres augmente alors que l'exposition reste étroitement concentrée",
      "evidence": "Les membres à risque ont augmenté de {delta}, tandis que {department} représentent toujours {percent} % de l'exposition.",
      "implication": "Si le risque de membre augmente, cette concentration peut augmenter rapidement. Prioriser la sensibilisation des membres à haut bilan dans le ministère exposé.",
      "actionLabel": "Communiquer d'abord avec les membres à risque"
    }
  },
  "departments": {
    "membership": "Adhésion",
    "golf": "Golf",
    "racquet": "Raquette",
    "spa": "Spa",
    "rooms": "Chambres",
    "events": "Évènements",
    "fitness": "Fitness",
    "other": "Autre"
  },
  "this_insight_could_not_be_displayed": "Cette perspicacité ne pouvait pas être affichée.",
  "no_chart_data_is_available": "Aucune donnée graphique n'est disponible.",
  "series": "Série:",
  "categories": "Catégories:",
  "data_is_unavailable": "les données ne sont pas disponibles",
  "comparison_data_is_available_for": "Les données de comparaison sont disponibles pour",
  "of_the": "Le",
  "displayed_periods_gaps_are_unavailable": "les périodes affichées; les écarts ne sont pas disponibles.",
  "partial_data_available_from": "Données partielles: disponibles",
  "categories_were_limited_to_the_most_significant_results": "Les catégories étaient limitées aux résultats les plus significatifs.",
  "view_data": "Voir les données",
  "download_csv": "Télécharger CSV",
  "open_in_module": "Ouvrez le module",
  "exact_data_used_for": "Données exactes utilisées",
  "current_period_is_incomplete_its_value_is_provisional": "* La période actuelle est incomplète; sa valeur est provisoire.",
  "about_this_chart": "À propos de ce graphique",
  "complete_through": "Complètement",
  "generated": ") · générés",
  "latest_observed_record": "Derniers enregistrements observés :",
  "compared_with": "Comparé avec",
  "the_current_period_is_incomplete": "La période actuelle est incomplète.",
  "club_inventory": "Inventaire des clubs",
  "show": "Montrez",
  "more": "plus",
  "fytd": "FYTD",
  "joined": "Joignez-vous",
  "renewal": "Renouvellement",
  "account": "Compte",
  "contact": "Contact",
  "recent_activity": "Activité récente",
  "no_recent_activity_recorded": "Aucune activité récente n'a été enregistrée.",
  "showing": "À montrer",
  "of_at_least": "au moins",
  "rows": "Des rangées.",
  "coverage": "Couverture",
  "comparison": "Comparaison",
  "revision": "· révision",
  "key_findings": "Principales conclusions",
  "supporting_chart_is_unavailable_or_no_longer_accessible": "Le tableau d'appui n'est pas disponible ou n'est plus accessible.",
  "risks_and_exceptions": "Risques et exceptions",
  "recommendations": "Recommandations",
  "intended_outcome": "Résultat escompté :",
  "next_actions": "Prochaines actions",
  "coverage_limitations": "Couverture et limites",
  "about_this": "À propos de ça.",
  "data_used": "Données utilisées",
  "why": "Pourquoi ?",
  "report_revision": "Révision du rapport",
  "calculation_date": "Date de calcul",
  "trading_picture": "Image de trading",
  "vs": "vs",
  "revenue_by_department": "Revenu par ministère",
  "variance": "Variation",
  "revenue_trend": "Tendance des recettes",
  "collections_by_method": "Collections par méthode",
  "privana_observations": "Observations de privana",
  "live_operational_weather": "Météo opérationnel en direct",
  "live_club_forecast_updated": "Prévisions du club en direct · Mis à jour",
  "this_file_is_no_longer_stored_generated_files_are_retained_for_7_days": "Ce fichier n'est plus stocké. Les fichiers générés sont conservés pendant 7 jours.",
  "available_until": "Disponible jusqu ' à",
  "loading_preview": "Chargement de l'aperçu...",
  "view_member": "Voir le membre",
  "create_golf_outing": "Créer Golf Outing",
  "event_title": "Titre de l'événement",
  "description": "Description",
  "max_capacity": "Capacité maximale",
  "start_time": "Démarrage",
  "end_time": "Heure de fin",
  "location": "Lieu",
  "weather_forecast": "Prévisions météorologiques",
  "golf_scope": "Portée de golf",
  "booked_players": "Joueurs inscrits",
  "tee_utilisation": "Utilisation des dents",
  "occupied_slots": "Emplacements occupés",
  "available_slots": "Fentes disponibles",
  "forecast_date": "Date prévue",
  "operational_risk": "Risque opérationnel",
  "current_snapshot": "Récapitulatif",
  "previous_year": "Année précédente",
  "for_the_displayed_periods": " pour les périodes affichées",
  "creating": "Créer...",
  "untitled": "Sans titre",
  "report": "Rapport",
  "noMatches": "Aucun résultat correspondant",
  "unavailableData": "Cette information n'est pas disponible en ce moment.",
  "assistUnavailable": "Aide temporairement indisponible. Veuillez réessayer ce message.",
  "draftConflict": "Ce projet n'a pas pu être mis à jour. Rechargez-le avant d'essayer à nouveau.",
  "queued": "Demande acceptée.",
  "running": "Privana Assist fonctionne...",
  "finalising": "Terminer votre réponse...",
  "cancelling": "Arrête...",
  "paused": "Pause",
  "failed": "Incapable de continuer",
  "openFile": "Ouvrir {name}",
  "downloadFile": "Télécharger {name}",
  "termUnavailable": "Les renseignements sur le terme d'adhésion n'ont pas pu être vérifiés en ce moment.",
  "noRenewal": "Aucune date de renouvellement explicite n'a été enregistrée.",
  "noTerm": "Aucun mandat d ' admission n ' a été enregistré.",
  "financeUnavailable": "L'information financière n'a pas pu être vérifiée en ce moment.",
  "accountAvailable": "Poste de compte disponible.",
  "viewProfile": "Voir le profil de membre",
  "previewFailed": "Aperçu indisponible.",
  "downloadFailed": "Téléchargement non disponible.",
  "openFailed": "Ouvrez indisponible.",
  "restricted": "Vous n'avez pas la permission de consulter cette information.",
  "references": {
    "outstanding": "Solde restant",
    "cancelled": "Réservation annulée ou remboursement",
    "engagement": "Faible tendance à la mobilisation"
  },
  "available": "Disponible",
  "partial": "Partiel",
  "unavailable": "Indisponible",
  "high": "Élevé",
  "medium": "Moyen",
  "low": "Faible",
  "unknown": "Inconnu",
  "result": "Résultat",
  "weatherLow": "Bien pour les opérations extérieures",
  "weatherElevated": "Risque de perturbation",
  "weatherHigh": "Risque de rupture élevé",
  "gusts": "rafales",
  "low_source_coverage": "certaines sources ont une couverture limitée",
  "insufficient_points": "seules des données historiques limitées sont disponibles",
  "partially_available": "certains domaines demandés n’ont pas renvoyé de preuves exploitables",
  "no_comparison_period": "la comparaison de la période précédente n'est pas disponible",
  "provisional_period": "la période actuelle n ' est pas complète",
  "source_coverage": "la couverture des sources est limitée",
  "coverageLimited": "{names} données n’étaient pas disponibles pour cette période, donc l’évaluation opérationnelle du rapport est limitée.",
  "coverageHelp": "Le présent rapport comprend les éléments de preuve disponibles et prend note des limites ci-dessous.",
  "revenueRecords": "Comptes rendus des recettes",
  "memberRecords": "Comptes rendus des membres",
  "receivableRecords": "Comptes débiteurs",
  "eventRecords": "Comptes rendus des événements",
  "elementRecords": "Dossiers d ' éléments",
  "managementRecords": "Documents de gestion disponibles",
  "and": " et ",
  "tableLabel": "{title} tableau",
  "becauseRecordsBegin": " parce que les enregistrements commencent sur {date}",
  "completed": "Complet",
  "unspecified": "Non précisé",
  "none": "Aucun",
  "confidenceBadge": "{value} confiance",
  "analyticalDescription": "Affichage {series} par {dimension} .",
  "analyticalView": "Vue analytique.",
  "governedResult": "Résultat analytique réglementé",
  "supportedEvidence": "Appuyé par les preuves disponibles.",
  "collapse": "Effondrement",
  "briefing": "Briefing",
  "working": "Travailler...",
  "originalReport": "Rapport initial",
  "revisionReport": "Révision du rapport précédent",
  "extensionReady": "Extension prêt",
  "transferringTarget": "Transfert jusqu'à {target} ...",
  "consultControls": "Contrôle des appels de consultation",
  "consultDialpad": "Cadran de consultation",
  "closeDialpad": "Fermer Dialpad",
  "sendDtmf": "Envoyer DTMF {digit}",
  "unmute": "Démêlé",
  "hangUp": "Accroche-toi.",
  "inProgress": "En cours",
  "consultation_active": "Consultation active",
  "financeStatuses": {
    "draft": "Brouillon",
    "submitted": "Soumis",
    "board_approved": "Conseil approuvé",
    "approved": "Postes approuvés",
    "locked": "Verrouillés",
    "favourable": "Favorable",
    "adverse": "Nocifs",
    "on_budget": "Budget",
    "consistent": "Cohérente",
    "mismatch": "Incohérence",
    "reconciled": "Reconciliés",
    "explained_difference": "Différence explicative",
    "unexplained_difference": "Différence inexpliquée",
    "insufficient_evidence": "Insuffisance des preuves"
  },
  "destination_prepared": "Destination préparée",
  "destination_ringing": "Destination sonnant",
  "consultation_failed": "Consultation échouée",
  "consultation_cancelling": "Annulation de la consultation",
  "consultation_cancelled": "Consultation annulée",
  "clubFallback": "Club",
  "atAGlance": "{club} en un coup d'oeil",
  "cc": "CC",
  "bcc": "BCC",
  "proceed": "Comment voulez-vous procéder ?",
  "selectMemberFailed": "Impossible de sélectionner ce membre. Veuillez réessayer.",
  "reviewSms": "Veuillez vérifier et confirmer avant d'envoyer ce SMS .",
  "confirmationCancelled": "Confirmation annulée. Aucun message n'a été envoyé.",
  "verifyAction": "Aider temporairement indisponible. Veuillez vérifier l'état de l'action avant la rentrée.",
  "discardedEdit": "Les ébauches supprimées ne peuvent pas être modifiées.",
  "saveDraftFailed": "Ça ne peut pas Enregistrer.",
  "discardDraftFailed": "Je ne peux pas.",
  "forwardedMessage": "Message transmis",
  "smsFailed": "SMS n'a pas envoyé.",
  "smsSimulation": "SMS simulation seulement — aucun message texte réel n'a été envoyé.",
  "smsSimulationLine": "Simulation uniquement ⚠️ Aucun SMS n’a été envoyé au membre.",
  "smsNotSent": "SMS non envoyé",
  "smsSuccess": "Message envoyé avec succès",
  "smsSent": "SMS a envoyé ident",
  "golfOutingPlaceholder": "Sortie de golf",
  "selectCourse": "Sélectionnez un cours...",
  "courseVenue": "Cours / nom du lieu",
  "allGolfCourses": "Tous les parcours de golf",
  "member_back_to_accommodations": "Retour aux hébergements",
  "member_your_booking": "votre réservation",
  "member_confirm_occupancy_settlement_method_and_submit_your_booking_request": "Confirmez l'occupation, la méthode de règlement et soumettez votre demande de réservation.",
  "member_booking_request_confirmed": "Demande de réservation confirmée",
  "member_your_accommodation_request_is_now_pending_confirmation_from_the_club_team": "Votre demande d'hébergement est maintenant en attente de confirmation de l'équipe du club.",
  "member_reservation_reference": "Référence de réservation :",
  "member_photos_coming_soon": "Photos à venir",
  "member_previous_photo": "Photo précédente",
  "member_next_photo": "Prochaine photo",
  "member_room_plan": "Plan de la chambre",
  "member_adults": "adultes;",
  "member_children": "enfants",
  "member_anything_we_should_prepare": "Tout ce qu'on devrait préparer ?",
  "member_special_requests_optional": "Demandes spéciales (facultatif)",
  "member_late_arrival_adjoining_rooms_dietary_preferences_or_anything_else": "Arrivée tardive, chambres attenantes, préférences alimentaires, ou autre chose.",
  "member_review_confirm": "Avis & Confirmation",
  "member_nights": "Nuits",
  "member_rooms_guests": "Chambres · Invités",
  "member_rooms": "chambres ·",
  "member_nightly_rate_per_room": "Tarif nocturne (par chambre)",
  "member_add_to_member_account": "Ajouter au compte membre",
  "member_pay_by_card_online": "Payer par carte en ligne",
  "member_pay_on_arrival": "Payez à l'arrivée",
  "member_this_room_type_does_not_yet_have_a_configured_rate_please_contact_the_club": "Ce type de chambre n'a pas encore de tarif configuré. Veuillez contacter le club.",
  "member_visual_coming_soon": "Visuel à venir",
  "member_rooms_available": "chambres disponibles",
  "member__night": "/ nuit",
  "member_stay_in": "Reste à l'intérieur",
  "member_style": "style",
  "member_choose_your_dates_and_room_setup_to_see_currently_available_suites": "Choisissez vos dates et la configuration de la chambre pour voir les suites actuellement disponibles.",
  "member_check_in_check_out": "Vérifier / Check-out",
  "member_guests_rooms": "Invités / Chambres",
  "member_add_rooms_as_needed": "Ajouter des chambres au besoin",
  "member_decrease_rooms": "Baisse des chambres",
  "member_increase_rooms": "Augmenter les chambres",
  "member_adults_2": "Adultes",
  "member_children_2": "Enfants",
  "member_check_availability": "Vérifier la disponibilité",
  "member_step_2": "Étape 2",
  "member_available_room_types": "Types de chambre disponibles",
  "member_loading_suites_and_rooms": "Chargement des suites et des chambres…",
  "member_no_rooms_are_available_to_request_right_now": "Aucune chambre n'est disponible pour le moment.",
  "member_accommodation_room_details": "Détails de la chambre",
  "member_close_room_details": "Détails de la chambre",
  "member_total_estimate": "Montant estimatif total",
  "member_continue_to_booking": "Continuer de réserver",
  "member_discover_club_programming": "Découvrez la programmation du club",
  "member_loading_activities": "Chargement d'activités...",
  "member_no_activities_are_available_right_now": "Aucune activité n ' est disponible en ce moment.",
  "member_view_sessions": "Séances de vues",
  "member_book_or_manage_your_reservation": "Réservez ou gérez votre réservation.",
  "member_back_to_activities": "Retour aux activités",
  "member_loading_sessions": "Chargement des sessions...",
  "member_no_sessions_are_scheduled_yet": "Aucune séance n ' est encore prévue.",
  "member_dismiss_notification": "Notification de rejet",
  "member_players": "joueurs ·",
  "member_can_cancel": "Peut annuler",
  "member_total_cost": "Total des dépenses",
  "member_no_players_listed": "Pas de joueurs listés",
  "member_no_add_ons": "Pas d'add-ons",
  "member_cancellation_policy_status": "État de la politique d ' annulation",
  "member_you_may_cancel_this_booking_online_under_the_club_s_cancellation_policy": "Vous pouvez annuler cette réservation en ligne dans le cadre de la politique d’annulation du club.",
  "member_cutoff": "Découpe :",
  "member_hours_before_tee_time": "heures avant l ' heure de la tee",
  "member_cancel_booking": "Annuler réservation",
  "member_you_may_cancel_this_racquet_booking_through_member_portal_cancellation": "Vous pouvez annuler cette réservation Racquet par l'annulation du portail membre.",
  "member_you_may_cancel_this_spa_booking_through_member_portal_cancellation": "Vous pouvez annuler cette réservation Spa par l'annulation du portail membre.",
  "member_fitness_booking": "Réservation de condition physique",
  "member_you_may_cancel_this_fitness_booking_through_member_portal_cancellation": "Vous pouvez annuler cette réservation Fitness par l'annulation du portail membre.",
  "member_full_stay_cost": "Coût de séjour complet",
  "member_you_may_cancel_this_hotel_rooms_booking_through_member_portal_cancellation": "Vous pouvez annuler cet hôtel / réservation de chambres par l'annulation du portail membre.",
  "member_need_to_adjust_this_booking_please_contact_the_club": "Besoin d'ajuster cette réservation? S'il vous plaît contacter le club.",
  "member_club_overview": "Aperçu du club",
  "member_resolving_member_profile": "Profil des membres en résolution",
  "member_welcome_to_your_private_sanctuary": "Bienvenue dans votre sanctuaire privé",
  "member_let_s_play": "Jouons !",
  "member_upcoming_bookings": "Réservations à venir",
  "member_your_next_experiences_at_the_club": "Vos prochaines expériences au club",
  "member_check_back_here_soon_for_more_exciting_club_news": "Revenez vite ici pour plus de nouvelles passionnantes du club!",
  "member_loading_club_news": "Chargement des nouvelles du club",
  "member_member_updates": "Mises à jour des membres",
  "member_preparing_pdf_viewer": "Préparer PDF...",
  "member_mark_as_read": "Marque telle que lue",
  "member_member_bookings": "Réservations de membres",
  "member_all_upcoming_experiences": "Toutes les expériences à venir",
  "member_upcoming": "à venir",
  "member_upcoming_bookings_carousel": "Prochaines réservations carousel",
  "member_select_a_booking_to_view_details": "Sélectionnez une réservation pour voir les détails",
  "member_choose_a_booking_from_the_list_to_see_policy_information_players_add_ons_payment_details_and_available_actions": "Choisissez une réservation dans la liste pour voir les informations de politique, les joueurs, les add-ons, les détails de paiement et les actions disponibles.",
  "member_close_cancellation_confirmation": "Confirmation d ' annulation",
  "member_cancel_this_tee_time": "Annulez cette horaires de départ ?",
  "member_this_will_cancel_your_tee_time_and_update_your_member_account_this_cannot_be_undone_online": "Cela va annuler votre départs et mettre à jour votre compte membre. Ceci ne peut pas être déconnecté en ligne.",
  "member_keep_booking": "Continuez.",
  "member_cancel_tee_time": "Annuler départs",
  "member_cancel_this_racquet_booking": "Annuler la réservation de Racquet ?",
  "member_this_will_cancel_your_booking_and_apply_the_club_cancellation_policy": "Cela annulera votre réservation et appliquera la politique d'annulation du club.",
  "member_cancel_this_spa_booking": "Annuler la réservation de Spa ?",
  "member_cancel_this_fitness_booking": "Annuler cette réservation de conditionnement physique?",
  "member_cancel_this_hotel_rooms_booking": "Annuler cet hôtel / Réservation de chambres?",
  "member_this_will_cancel_your_stay_and_apply_the_club_cancellation_policy": "Cela annulera votre séjour et appliquera la politique d'annulation du club.",
  "member_explore_exclusive_events": "Découvrez les événements exclusifs...",
  "member_search_titles_venues_or_occasion_type": "Recherche de titres, de lieux ou de type occasionnel",
  "member_event_timeframe": "Calendrier de l'événement",
  "member_my_calendar": "Mon calendrier",
  "member_confirmed_attendance": "Participation confirmée",
  "member_accessibility": "Accessibilité",
  "member_remove_guest": "Supprimer l'invité",
  "member_attendance_notes": "Notes de présence",
  "member_dietary_needs_accessibility_notes_or_concierge_requests": "Besoins alimentaires, notes d'accessibilité ou demandes de concierge",
  "member_book_facilities": "Installations de livres",
  "member_choose_your_next_activity": "Choisissez votre prochaine activité",
  "member_facilities_could_not_be_refreshed": "Les installations ne pouvaient pas être rafraîchies.",
  "member_loading_facilities": "Installations de chargement",
  "member_facilities_will_appear_here_when_your_club_enables_them": "Les installations apparaîtront ici lorsque votre club leur permettra.",
  "member_available_times": "CRÉNEAUX DISPONIBLES",
  "member_loading_availability": "Chargement de disponibilité...",
  "member_no_available_times_for_this_day": "Pas de temps disponible pour cette journée.",
  "member_loading_schedule": "Chargement de l'horaire...",
  "member_no_upcoming_fitness_classes_with_availability": "Pas de cours de fitness à venir avec disponibilité.",
  "member_sessions": "Sessions",
  "member_view_open_groups": "Voir les groupes ouverts",
  "member_view_rates": "Taux de vue",
  "member_no_available_tee_times_for_this_day": "Pas de départs disponible pour cette journée.",
  "member_up_to": "Jusqu'à",
  "member_players_2": "joueurs",
  "member_book_now": "Réservez maintenant",
  "member_rates_are_not_available_yet_please_contact_the_pro_shop": "Les tarifs ne sont pas encore disponibles. S'il vous plaît contacter le pro shop.",
  "member_back_to_tee_times": "Retour à l'heure des tee",
  "member_course_rates": "Tarifs des cours",
  "member_loading_course": "Chargement de cours...",
  "member_select_rate_type": "Sélectionnez le type de taux",
  "member_member_rates": "Taux de vacance de postes",
  "member_guest_rates": "Tarifs des clients",
  "member_pricing": "tarification",
  "member__hole": "- Connard",
  "member_fetching_available_courses_for_your_club": "Obtenir des cours disponibles pour votre club.",
  "member_choose_your_course": "Choisissez votre cours",
  "member_select_a_course_to_view_available_tee_times": "Sélectionnez un cours pour afficher les départs disponibles.",
  "member_no_active_courses_are_available_for_booking_yet": "Aucun cours actif n'est encore disponible pour la réservation.",
  "member_court": "court",
  "member_private_booking": "Réservation privée",
  "member_open_match": "Match ouvert",
  "member_match_type": "Type de Match",
  "member_competitive": "Compétitivité",
  "member_who_can_join": "Qui peut se joindre",
  "member_host_approval": "Homologation",
  "member_direct_join": "Jonction directe",
  "member_optional_note": "Note facultative",
  "member_anything_players_should_know": "Tout ce que les joueurs devraient savoir ?",
  "member_add_to_your_booking": "Ajouter à votre réservation",
  "member_view_other_times": "Voir d'autres fois",
  "member_close_player_sheet": "Fermer la feuille de lecteur",
  "member_search_by_name": "Recherche par nom",
  "member_searching_members": "Membres de la recherche",
  "member_sport_not_supported": "Sport non supporté",
  "member_we_couldn_t_recognize_this_sport_please_return_to_facilities": "Nous ne pouvions pas reconnaître ce sport.",
  "member_back_to_courts": "Retour aux courts",
  "member_confirm_your_court": "Confirmez votre cour",
  "member_book_a_court": "Livrer un court",
  "member_create_open_match": "Créer une correspondance ouverte",
  "member_select_open_match_type": "Sélectionnez le type de match ouvert",
  "member_select_join_policy": "Sélectionnez la politique d'adhésion",
  "member_open_match_note": "Note du match ouvert",
  "member_optional_details_for_players_joining": "Détails optionnels pour rejoindre les joueurs",
  "member_mobile_for_updates": "Mobile pour les mises à jour",
  "member_email_for_confirmation": "Courriel pour confirmation",
  "member__add_player": "+ Ajouter le joueur",
  "member_maximum_players_reached_for_this_court": "Les joueurs maximums ont atteint pour cette cour.",
  "member_enhance_your_visit": "Améliorez votre visite",
  "member_no_add_ons_available_for_this_sport": "Pas d'add-ons disponible pour ce sport.",
  "member_racquet_booking": "Réservation racquet",
  "member_estimated_total": "Montant estimatif total",
  "member_calculated_from_live_pricing_policy": "Calculé à partir de la politique de prix en direct",
  "member_default_session": "Session par défaut :",
  "member_member_rate_on_file": "Taux de membre au dossier",
  "member_guest_rate_on_file": "Tarif client au dossier",
  "member_left": "gauche",
  "member_skill": "Habilitation",
  "member_vacant_spot": "Vacance spot",
  "member_no_pending_join_requests_right_now": "Pas de demandes d'adhésion en attendant.",
  "member_pending_invites": "Appels en attente",
  "member_back_to_racquet_availability": "Retour à la disponibilité racquet",
  "member_loading_match_details": "Charger les détails du match...",
  "member_back_to_facilities": "Retour aux installations",
  "member_no_courts_available_for": "Pas de courts disponibles",
  "member_select_court_date": "Sélectionnez la date du court",
  "member_open_matches": "Les matchs ouverts",
  "member_loading_open_matches": "Chargement des matchs ouverts...",
  "member_no_open_matches_available_for_this_date": "Aucune correspondance ouverte n'est disponible pour cette date.",
  "member_choose_a_time": "Choisissez un temps",
  "member_no_available_start_times_for_this_day": "Pas de temps de départ disponible pour cette journée.",
  "member_available_start_times": "Heures de départ disponibles",
  "member_choose_a_court": "Choisir un court",
  "member_no_courts_are_available_for_this_time": "Aucun court n ' est disponible pour cette période.",
  "member_no_slots_available_for_this_day": "Pas de machines à sous disponibles pour ce jour.",
  "member_open_matches_to_join": "Des matchs ouverts pour rejoindre",
  "member_spots_left": "points laissés à gauche",
  "member_your_match": "Votre correspondance",
  "member_view_requests": "Demandes de vue",
  "member_payment_required": "Paiement requis",
  "member_due": "exigible",
  "member_add_to_account": "Ajouter au compte",
  "member_pay_online": "Payer en ligne",
  "member_you_are_in_this_match": "Tu es dans ce match.",
  "member_host_controls": "Commandes d ' hébergement",
  "member_manage_open_match": "Gérer le match ouvert",
  "member_manage_open_match_requests": "Gérer les demandes de correspondance ouvertes",
  "member_pay_online_for_open_match": "Payer en ligne pour le match ouvert",
  "member_payment_summary": "Résumé des paiements",
  "member_match_time_date": "Temps de correspondance/date",
  "member_cardholder_name": "Nom du titulaire de la carte",
  "member_card_number": "Numéro de carte",
  "member_expiry": "Expiration",
  "member_mm_yy": "MM/YY",
  "member_billing_postcode_zip": "Code postal de facturation / ZIP",
  "member_online_card_payments_are_not_enabled_yet": "Les paiements en ligne ne sont pas encore activés.",
  "member_confirm_payment": "Confirmer le paiement",
  "member_members_portal": "MEMBRES PORTÉES",
  "member_browse_partner_clubs_and_request_a_guest_pass_to_visit": "Parcourez les clubs partenaires et demandez un laissez-passer pour visiter.",
  "member_search_by_club_or_location": "Recherche par club ou lieu",
  "member_loading_reciprocal_clubs": "Chargement des clubs de réciprocité...",
  "member_no_partner_clubs_available_yet": "Aucun club partenaire n'est encore disponible.",
  "member_amenities_coming_soon": "Commodités à venir",
  "member_visit_website": "Visiter le site Web",
  "member_reciprocal_club": "Club de réciprocité",
  "member_amenities_coming_soon_2": "Les commodités arrivent bientôt.",
  "member_visit_date": "Date de la visite",
  "member_note_message_optional": "Note/message (facultatif)",
  "member_let_us_know_anything_helpful_for_your_visit": "Faites-nous savoir quelque chose d'utile pour votre visite.",
  "member_request_sent": "Demande envoyée !",
  "member_your_guest_pass_request_has_been_submitted_we_ll_notify_you_once_it_s_approved": "Votre demande de laissez-passer a été soumise. Nous vous avertirons une fois qu'elle aura été approuvée.",
  "member_request_reference": "Demande de référence:",
  "member_back_to_reciprocal_clubs": "Retour aux clubs de réciprocité",
  "member_back_to_services": "Retour aux services",
  "member_choose_a_service": "Choisissez un service",
  "member_search_services": "Services de recherche",
  "member_loading_services": "Chargement des services...",
  "member_no_spa_services_available": "Pas de services de spa disponibles.",
  "member_holes": "trous",
  "member_confirm_your_time": "Confirmez votre temps",
  "member_please_select_holes_to_continue": "Veuillez sélectionner des trous pour continuer.",
  "member_open_group": "GROUPE OUVERT",
  "member_open_group_toggle": "Ouvrez le jeu de groupe",
  "member_open_group_2": "Groupe ouvert",
  "member_open_groups_not_available_for_this_player_mix": "Groupes ouverts non disponibles pour ce mélange de lecteur.",
  "member_looking_for": "Cherche pour",
  "member_open_group_size": "Taille du groupe ouvert",
  "member_player": "Joueur",
  "member_min_handicap_optional": "Handicapé mineur (facultatif)",
  "member_e_g_10_0": "Par exemple, 10,0",
  "member_max_handicap_optional": "Max handicap (facultatif)",
  "member_e_g_24_0": "par exemple 24.0",
  "member_note_for_guests_optional": "Note pour les clients (facultatif)",
  "member_share_expectations_or_preferences": "Partager les attentes ou les préférences",
  "member_spots_available": "Spots disponibles:",
  "member_enhance_your_round": "Améliorez votre tour",
  "member_open_groups_to_join": "Groupes ouverts à rejoindre",
  "member_play_with_others": "Jouer avec d'autres",
  "member_no_open_groups_for_this_date_yet": "Pas encore de groupes ouverts pour cette date.",
  "member__spots_available": "· Spots disponibles:",
  "member_golf_booking": "Réservation de golf",
  "member_open_group_2_3": "Groupe ouvert",
  "member_retry_price": "Prix de rentrée",
  "member_includes_add_ons_selected": "Comprend les add-ons sélectionnés",
  "member_booking_checkout": "Réservez votre commande",
  "member_go_to_dashboard": "Allez au tableau de bord",
  "member_member_profile": "Profil des membres",
  "member_mobile_bottom_navigation": "Navigation mobile vers le bas",
  "member_clearing": "Dédouanement",
  "member_loading_notifications": "Chargement des notifications...",
  "member_no_notifications_yet": "Pas encore de notifications",
  "member_pending_confirmation": "Confirmation en attente",
  "member_select_a_room_type": "Sélectionnez un type de chambre",
  "member_confirm_booking": "Confirmer la réservation",
  "member_member_account_club_billing": "Compte membre / billet de club",
  "member_fitness_class": "Cours de fitness",
  "member_hotel_stay": "Séjour de l'hôtel",
  "member_venue_service": "Lieu / service",
  "member_you_may_cancel_this_dining_reservation_through_member_portal_cancellation": "Vous pouvez annuler cette réservation par l'annulation du portail membre.",
  "member_close_all_club_news": "Fermez toutes les nouvelles du club",
  "member_close_entry_notification": "Avertissement d ' entrée",
  "member_close_club_news": "Nouvelles du club",
  "member_close_all_upcoming_bookings": "Fermez toutes les réservations à venir",
  "member_past_experiences": "expériences passées",
  "member_live_experiences": "expériences vécues",
  "member_no_events_match_your_search_right_now": "Aucun évènements ne correspond à votre recherche.",
  "member_no_past_events_just_yet": "Pas encore d'événements passés.",
  "member_no_upcoming_events_right_now_please_check_back_soon": "Pas d'événements à venir.",
  "member_signature_event": "L ' événement signature",
  "member_an_exceptional_club_gathering": "Un club exceptionnel.",
  "member_club_venue": "Lieu du club",
  "member_guest_details": "Détails des clients",
  "member_confirm_attendance": "Confirmer la présence",
  "member_open_match_enabled": "Match ouvert activé",
  "member_none_selected": "Aucun sélectionné",
  "member_book_court": "Court de livres",
  "member_pending_join_requests": "En attente de demandes de participation",
  "member_select_a_court": "Sélectionnez un court",
  "member_selected_day": "Jour choisi",
  "member_request_guest_pass": "Demande à Guest Pass",
  "member_all_caught_up": "Tout le monde s'est arrêté",
  "member_unable_to_load_activities": "Incapable de charger des activités.",
  "member__count_upcoming_session": "Sessions à venir : {count}",
  "member__count_upcoming_sessions": "Sessions à venir : {count}",
  "member_time_to_be_announced": "Heure à être annoncée",
  "member_unable_to_update_booking": "Impossible de mettre à jour la réservation.",
  "member_join_waitlist": "Joignez-vous à Waitlist",
  "member_join": "Rejoignez-nous.",
  "member__count_booked": "Réservés : {count}",
  "member_unable_to_clear_notifications": "Incapables à des notifications claires",
  "member__count_new": "Nouveaux : {count}",
  "member_unable_to_load_reciprocal_clubs": "Incapable de charger des clubs de réciprocité.",
  "member_please_select_a_visit_date_to_request_a_guest_pass": "Veuillez sélectionner une date de visite pour demander un laissez-passer.",
  "member_unable_to_submit_request": "Incapable de soumettre une demande.",
  "member_we_could_not_load_accommodations_right_now_please_try_again_shortly": "Nous ne pouvions pas charger les hébergements en ce moment. Veuillez réessayer.",
  "member_please_choose_a_check_in_and_check_out_date": "Veuillez choisir une date d'enregistrement et de départ.",
  "member_check_out_must_be_after_check_in": "L'enregistrement doit être après l'enregistrement.",
  "member_please_add_at_least_one_guest": "S'il vous plaît ajouter au moins un invité.",
  "member_please_choose_valid_dates_before_requesting_a_booking": "Veuillez choisir les dates valides avant de demander une réservation.",
  "member_we_were_unable_to_submit_your_request_please_try_again": "Nous n'avons pas pu soumettre votre demande. Veuillez réessayer.",
  "member_unable_to_load_event_details": "Impossible de charger les détails de l'événement",
  "member_each_guest_needs_a_first_and_last_name": "Chaque invité a besoin d'un prénom et d'un nom.",
  "member_registration_failed": "Enregistrement échoué",
  "member_location_coming_soon": "Lieu à venir",
  "member_availability_on_request": "Disponibilité sur demande",
  "member_select_your_stay_dates": "Choisissez vos dates de séjour",
  "member_date_to_be_announced": "Date à annoncer",
  "member_you_re_in": "Tu es là.",
  "member__count_of_capacity_places_remaining": "Places restantes : {count} sur {capacity}",
  "member_guests_allowed_up_to_count": "Personnes admises: jusqu'à {count}",
  "member_guests_allowed": "Invités autorisés",
  "member_guests_not_permitted": "Invités non autorisés",
  "member_more_details_will_be_announced_shortly": "Plus de détails seront annoncés sous peu.",
  "member_host_member": "Host · Membre",
  "member_live_price": "Prix en direct",
  "member_add_name": "Ajouter {name}",
  "member_member_on_file": "Membre au dossier",
  "member_search_member_or_enter_guest_name": "Membre de la recherche ou nom d'invité",
  "member_search_and_select_a_member": "Rechercher et sélectionner un membre",
  "member_host": "Hôte",
  "member_tap_to_book": "Robinet à réserver",
  "member_join_now": "Rejoindre maintenant",
  "member_request_spot": "Demande d ' admission",
  "member_balance_loading": "Chargement du solde",
  "member_explore_events": "Explorez les événements",
  "member_racquet_open_match": "Racquet · match ouvert",
  "member_club_reservation": "Réservation du club",
  "member_this_booking_was_paid_online_please_contact_the_club_directly_if_you_wish_to_cancel_or_discuss_a_refund": "Cette réservation a été payée en ligne. Veuillez contacter le club directement si vous souhaitez annuler ou discuter d'un remboursement.",
  "member_the_online_cancellation_period_has_passed_please_contact_the_club": "La période d'annulation en ligne est passée. S'il vous plaît contacter le club.",
  "member_online_cancellation_is_not_available_for_this_booking_please_contact_the_club": "L'annulation en ligne n'est pas disponible pour cette réservation. Veuillez contacter le club.",
  "member_unable_to_cancel_booking": "Impossible d'annuler la réservation.",
  "member_your_tee_time_has_been_cancelled": "Votre départs a été annulé.",
  "member_this_booking_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "Cette réservation est à l'intérieur de la période de préavis d'annulation. Veuillez contacter le club pour annuler cette réservation.",
  "member_please_contact_the_club_to_cancel_this_booking": "Veuillez contacter le club pour annuler cette réservation.",
  "member_refund_outcome_no_refund": "Résultat du remboursement : pas de remboursement",
  "member_cancellation_requires_manual_review": "L'annulation nécessite un examen manuel.",
  "member_unable_to_cancel_booking_please_contact_the_club": "Impossible d'annuler la réservation. S'il vous plaît contacter le club.",
  "member_your_racquet_booking_has_been_cancelled": "Votre réservation de raquette a été annulée.",
  "member_your_spa_booking_has_been_cancelled": "Votre réservation a été annulée.",
  "member_your_fitness_booking_has_been_cancelled": "Votre réservation de fitness a été annulée.",
  "member_this_stay_is_inside_the_cancellation_notice_period_please_contact_the_club_to_cancel_this_booking": "Ce séjour est à l'intérieur de la période de préavis d'annulation. S'il vous plaît contacter le club pour annuler cette réservation.",
  "member_your_hotel_booking_has_been_cancelled": "Votre réservation d'hôtel a été annulée.",
  "member_cancellation_not_available_via_the_mobile_app": "Annulation non disponible via l'application mobile.",
  "member_the_online_cancellation_window_has_closed_please_contact_the_club": "La fenêtre d'annulation en ligne est fermée. S'il vous plaît contacter le club.",
  "member_this_reservation_can_no_longer_be_cancelled": "Cette réservation ne peut plus être annulée.",
  "member_this_reservation_could_not_be_found_please_contact_the_club": "Cette réservation n'a pas été trouvée. Veuillez contacter le club.",
  "member_cancellation_is_not_currently_available_please_contact_the_club": "L'annulation n'est pas actuellement disponible. Veuillez contacter le club.",
  "member_your_tee_time_is_confirmed": "Votre départs est confirmé",
  "member_your_table_is_reserved": "Votre table est réservée.",
  "member_your_stay_is_confirmed": "Votre séjour est confirmé",
  "member_your_open_match_is_live": "Votre match ouvert est en direct",
  "member_your_booking_is_confirmed": "Votre réservation est confirmée.",
  "member_open_match_created": "Ouvrir le match créé",
  "member_your_match_is_now_visible_to_eligible_club_members_who_can_join_or_request_a_place_using_your_chosen_join_policy": "Votre match est maintenant visible par les membres admissibles du club, qui peuvent se joindre ou demander un endroit en utilisant votre politique de rejoindre choisie.",
  "member_loading_booking_details": "Chargement des détails de réservation",
  "member_club_experience": "Expérience du club",
  "member_players_count_of_capacity": "Joueurs · {count} de {capacity}",
  "member__count_places_open_type_policy": "Places disponibles : {count} · {type} · {policy}",
  "member__adults_adults_children_children_rooms_rooms": "{adults} adultes, {children} enfants · {rooms} chambres",
  "member_stay_guests": "Reste avec toi.",
  "member_unable_to_load_course_details_right_now": "Impossible de charger les détails du cours en ce moment.",
  "member_unable_to_load_this_tee_time_please_return_to_tee_times_and_try_again": "Incapable de charger ce départs. S'il vous plaît revenir à l'horaires de départ et essayer à nouveau.",
  "member_at_least_one_player_is_required": "Au moins un joueur est requis.",
  "member_please_select_holes_9_or_18": "Veuillez sélectionner les trous (9 ou 18).",
  "member_select_how_many_players_you_want_to_join_your_open_group": "Sélectionnez combien de joueurs vous voulez rejoindre votre groupe ouvert.",
  "member_open_group_spots_would_exceed_the_maximum_of_4_players": "Les points de groupe ouverts dépasseraient le maximum de 4 joueurs.",
  "member_this_tee_time_is_no_longer_available_please_reselect_a_tee_time": "Ce départs n'est plus disponible, s'il vous plaît résélectionner un départs.",
  "member_we_can_t_price_this_tee_time_right_now_please_try_another_time_or_contact_the_club": "Nous ne pouvons pas prix cette horaires de départ en ce moment. S'il vous plaît essayez une autre fois ou contactez le club.",
  "member_we_couldn_t_calculate_your_booking_price_try_again_in_a_moment": "Nous ne pouvions pas calculer votre prix de réservation. Essayez de nouveau dans un instant.",
  "member_unable_to_join_this_open_group_right_now": "Impossible de rejoindre ce groupe ouvert en ce moment.",
  "member_we_could_not_complete_the_booking_please_check_your_details_and_try_again": "Nous ne pouvions pas compléter la réservation. S'il vous plaît vérifier vos coordonnées et essayez à nouveau.",
  "member_court_details_not_loaded": "Détails de la cour non chargés",
  "member_start_time_missing": "Temps de départ manquant",
  "member_please_resolve_player_details": "S'il vous plaît résoudre les détails du joueur",
  "member_unable_to_load_court_details_right_now": "Impossible de charger les détails du court.",
  "member_please_select_a_valid_duration_for_this_court_and_time": "Veuillez sélectionner une durée valide pour cette cour et l'heure.",
  "member_invalid_sport_type": "Type de sport invalide",
  "member_unable_to_join_open_match_right_now": "Impossible de rejoindre le match ouvert en ce moment.",
  "member_spot_joined_payment_required_to_finalize_your_spot": "Paiement requis pour finaliser votre spot.",
  "member_request_sent_you_will_be_notified_if_approved": "Demande envoyée. Vous serez avisé si approuvé.",
  "member_unable_to_complete_payment_right_now": "Impossible d'effectuer le paiement en ce moment.",
  "member_charged_to_account": "Montant imputé sur le compte",
  "member_unable_to_load_open_match_details_right_now": "Impossible de charger les détails du match en ce moment.",
  "member_unable_to_update_join_request": "Impossible de mettre à jour la demande de jointure.",
  "member_request_approved": "Demande approuvée.",
  "member_request_rejected": "Demande rejetée.",
  "member_unable_to_load_this_course_right_now": "Impossible de charger ce cours en ce moment.",
  "member_unable_to_load_tee_times_right_now": "Impossible de charger des fois de tee en ce moment.",
  "member_course_not_found_or_inactive": "Cours non trouvé ou inactif.",
  "member_you_already_joined_this_open_group": "Vous avez déjà rejoint ce groupe ouvert.",
  "member_this_open_group_is_full": "Ce groupe ouvert est plein.",
  "member_this_booking_is_no_longer_open_for_joins": "Cette réservation n'est plus ouverte pour les participants.",
  "member_this_booking_is_no_longer_available": "Cette réservation n'est plus disponible.",
  "member_we_could_not_find_your_member_profile_for_this_club": "Nous n'avons pas trouvé votre profil membre pour ce club.",
  "member_you_are_not_eligible_to_join_this_open_group": "Vous n'êtes pas admissible à rejoindre ce groupe ouvert.",
  "member_member_name_required": "Nom du membre requis",
  "member_guests_are_not_allowed_for_this_course_please_select_a_member": "Vous n'êtes pas autorisé pour ce cours. Veuillez sélectionner un membre.",
  "member_select_a_member_from_the_list": "Sélectionnez un membre dans la liste",
  "member_guest_full_name_email_and_phone_are_required": "Nom complet de l'invité, email et téléphone sont requis",
  "member_we_could_not_complete_the_booking_please_try_again": "Nous ne pouvions pas terminer la réservation. Veuillez réessayer.",
  "member_primary_member_required": "Membre principal requis",
  "member_guests_are_not_allowed_on_this_court": "Les clients ne sont pas autorisés sur cette cour",
  "member_guest_email_and_phone_are_required": "Un e-mail et un téléphone sont requis",
  "member_available_tee_times": "horaires de départ disponibles",
  "member_select_a_course": "Sélectionnez un cours",
  "member_back_to_courses": "Retour aux cours",
  "member_choose_your_service": "Choisissez votre service",
  "member_book_a_class": "Réservez une classe",
  "member_that_court_has_just_been_taken_choose_another_available_time": "Ce court vient d'être pris. Choisissez un autre temps disponible.",
  "member_payment_could_not_be_completed_your_court_has_not_been_booked": "Le paiement n'a pas pu être effectué. Votre court n'a pas été réservé.",
  "member_we_couldn_t_complete_your_booking_your_court_has_not_been_booked_or_charged": "Nous ne pouvions pas compléter votre réservation. Votre cour n’a pas été réservée ou chargée.",
  "member_we_couldn_t_complete_your_booking_please_try_again": "Nous ne pouvions pas compléter votre réservation. Veuillez réessayer.",
  "member_unable_to_load_course_rates_right_now": "Impossible de charger les taux de cours en ce moment.",
  "member_unable_to_load_courses_right_now": "Impossible de charger des cours en ce moment.",
  "member_home": "Maison",
  "member_dining": "Salle à manger",
  "member_profile": "Profil",
  "member_member": "Membre",
  "member_dashboard": "Tableau de bord",
  "member_club": "Club",
  "member_select_date": "Sélectionnez la date",
  "member__count_holes": "Trous : {count}",
  "member_player_caption": "Joueur",
  "member_players_caption": "Joueurs",
  "member_guests": "invités",
  "member_joined": "Joignez-vous",
  "member_friendly": "Amicalement",
  "member_notification": "Notification",
  "member_please_try_again": "Veuillez réessayer.",
  "member_notifications": "Notifications",
  "member_loading": "Chargement…",
  "member_refresh": "Actualiser",
  "member_clear_all": "Tout effacer",
  "member_activities": "Activités",
  "member_academy": "Académie",
  "member_reciprocal_clubs": "Clubs réciproques",
  "member_accommodations": "Logements",
  "member_voting": "Vote",
  "member_review": "Examen",
  "member_dates": "Dates",
  "member_occupancy": "Occupation",
  "member_room": "Chambre",
  "member_room_type": "Type de chambre",
  "member_select_dates": "Sélectionnez les dates",
  "member_total": "Total",
  "member_from": "De",
  "member_view_details": "Voir détails",
  "member_check_in": "Enregistrement",
  "member_check_out": "Départ",
  "member_rooms_caption": "Chambres",
  "member_close": "Fermer",
  "member_room_details": "Détails de la chambre",
  "member_cancel": "Annuler",
  "member_no_upcoming_sessions": "Pas de sessions à venir",
  "member_activity": "Activité",
  "member_full": "Complète",
  "member_unable_to_load_activity": "Incapable de charger l'activité.",
  "member_waitlisted": "Waitlisteded",
  "member_available": "disponible",
  "member_capacity_count": "Capacité: {count}",
  "member_current_balance": "Solde actuel",
  "member_contact_front_desk": "Contacter la réception",
  "member_golf_booking_caption": "Réservation de golf",
  "member_reservation": "Réservation",
  "member_open": "ouvert",
  "member_pdf_announcement": "PDF annonce",
  "member_tee_time": "Départ",
  "member_this_booking_has_already_been_cancelled": "Cette réservation a déjà été annulée.",
  "member_golf_course": "Terrain de golf",
  "member_booked": "réservé",
  "member_date": "Date",
  "member_holes_caption": "Trous",
  "member_add_ons": "Suppléments",
  "member_qty": "Qté",
  "member_deadline": "Date limite :",
  "member_racquet_booking_caption": "Réservation racquet",
  "member_spa_booking": "Réservation de spa",
  "member_spa": "Spa",
  "member_service": "Service",
  "member_spa_service": "Soin spa",
  "member_fitness_class_caption": "Classe de condition physique",
  "member_fitness": "Fitness",
  "member_hotel_rooms": "Hôtel / Chambres",
  "member_accommodation": "Hébergement",
  "member_dining_area": "Zone d ' essai",
  "member_party_size": "Taille de la Partie",
  "member_cost": "Coût",
  "member_status": "Statut",
  "member_good_morning": "Bonjour.",
  "member_view_all": "Voir tous",
  "member_club_news": "Nouvelles du club",
  "member_retry": "Réessayer",
  "member_member_portal_entry_notification": "Notification de l ' entrée du portail",
  "member_of": "des",
  "member_loading_reservation_details": "Chargement des détails de réservation...",
  "member_complimentary": "Complimentaire",
  "member_unable_to_load_events": "Incapable de charger des événements",
  "member_upcoming_caption": "À venir",
  "member_past_events": "Évènements passés",
  "member_event": "Événement",
  "member_reserved": "Réservé",
  "member_reserve": "Réserve",
  "member_add_guest": "Ajouter un invité",
  "member_first_name": "Prénom",
  "member_last_name": "Nom",
  "member_email": "E-mail",
  "member_phone": "Téléphone",
  "member_dietary": "Régime alimentaire",
  "member_notes": "Notes",
  "member_guest": "Invité",
  "member_try_again": "Réessayer",
  "member_member_price": "Prix Membres",
  "member_continue": "Continuer",
  "member_classes": "Cours",
  "member_coach": "Entraîneur",
  "member_golf": "Golf",
  "member_loading_tee_times": "Chargement des départs...",
  "member_golf_tee_times": "Départs de golf",
  "member_select": "Sélectionner",
  "member_unable_to_load": "Impossible à charger",
  "member_back": "Retour",
  "member_min": "min.",
  "member_booking_type": "Type de réservation",
  "member_add_player": "Ajouter le joueur",
  "member_guest_name": "Nom de l'invité",
  "member_no_booking_durations_are_configured_for_this_court": "Aucune durée de réservation n'est configurée pour ce court.",
  "member_racquet": "Raquette",
  "member_duration": "Durée",
  "member_select_duration": "Durée",
  "member_select_booking_type": "Sélectionnez le type de réservation",
  "member_remove": "Retirer",
  "member_name": "Nom",
  "member_guest_phone": "Téléphone Invité",
  "member_confirmed": "confirmé",
  "member_pending_requests": "Demandes en suspens",
  "member_none": "Aucun",
  "member_reject": "Rejet",
  "member_approve": "Approfondissement",
  "member_loading_courts": "Chargement des courts...",
  "member_show_less": "Montrer moins",
  "member_availability": "Disponibilité",
  "member_unavailable": "Indisponible",
  "member_awaiting_approval": "Attendant l ' approbation",
  "member_checkout": "Paiement",
  "member_grid": "Quadrillage",
  "member_list": "Liste",
  "member_reciprocal_club_caption": "Club de réciprocité",
  "member_more": "plus",
  "member__count_left": "Restants : {count}",
  "member_limited_availability": "Disponibilité limitée",
  "member_creating_match": "Créer le match...",
  "member_reserving_court": "Reserving court...",
  "member_manage_activities": "Gérer les activités",
  "member_you_are_not_assigned_to_any_activities": "Vous n'êtes affecté à aucune activité.",
  "member_managed_activity": "Activité gérée",
  "member_manage_sessions": "Gérer les sessions",
  "member_unable_to_load_sessions": "Impossible de charger des sessions.",
  "member_unable_to_update_session": "Incapable de mettre à jour la session.",
  "member_you_do_not_have_access_to_this_activity": "Vous n'avez pas accès à cette activité.",
  "member_viewing_roster": "Liste de vues",
  "member_plan_your_next_experience_with_precision_and_ease": "Planifiez votre prochaine expérience avec précision et facilité.",
  "member_add_a_concierge_note": "Ajouter une note de concierge",
  "member_decrease_adults_for_room_room": "Diminution des adultes pour la chambre {room}",
  "member_increase_adults_for_room_room": "Augmenter les adultes pour la chambre {room}",
  "member_decrease_children_for_room_room": "Diminuer les enfants pour la chambre {room}",
  "member_increase_children_for_room_room": "Augmenter les enfants pour la chambre {room}",
  "member__holes_hole_pricing": "{holes} - prix des trous",
  "member_pay_amount": "Payez {amount}",
  "member_guest_count": "Invité {count}",
  "member_member_count": "Membre # {count}",
  "member_calculating": "Calculer...",
  "member_choose_duration_for_name": "Durée du choix pour {name}",
  "member_book_sport": "Livre {sport}",
  "member_see_all_count": "Voir tous les {count}",
  "member_view_roster": "Voir le fichier",
  "member_unable_to_load_roster": "Incapable de charger la liste.",
  "member_unable_to_create_session": "Incapable de créer une session.",
  "member_sessions_caption": "Sessions",
  "member_add_session": "Ajouter la session",
  "member_no_sessions_yet": "Pas encore de séances.",
  "member_cancelled": "Annulé",
  "member_active": "Actif",
  "member_capacity": "Capacité",
  "member_roster": "Planning du personnel",
  "member_clear": "Effacer",
  "member_loading_roster": "Chargement de la liste...",
  "member_no_bookings_yet": "Pas encore de réservation.",
  "member_member_caption": "Membre",
  "member_select_a_session_to_view_the_roster": "Sélectionnez une session pour afficher le fichier.",
  "member_start_time": "Temps de démarrage",
  "member_select_time": "Sélectionnez le temps",
  "member_end_time": "Heure de fin",
  "member_optional": "Facultatif",
  "member_processing_payment": "Paiement de traitement...",
  "member_remove_name": "Supprimer {name}",
  "member_pending": "En attente",
  "member_paid": "Payé",
  "member_completed": "Terminé",
  "member_no_show": "Absence",
  "member_refunded": "Remboursé",
  "member_failed": "Échec",
  "member_expired": "Expiré",
  "member_held": "tenue",
  "member_status_unavailable": "Statut indisponible",
  "member_booking": "Réservation...",
  "member_requesting": "Demande...",
  "member_joining": "Rejoindre...",
  "member_guest_full_name": "Nom complet de l'invité",
  "member_book_tee_time": "Livre départs",
  "member_booking_image_unavailable": "Image de réservation non disponible",
  "member_expected_refund_amount": "Remboursement prévu: {amount}",
  "member_expected_refund_amount_cancellation_fee_fee": "Remboursement prévu: {amount} ; frais d'annulation {fee}",
  "member__minutes_minutes_price": "{minutes} minutes {price}",
  "member_open_type_match_at_time_on_court_count_places_left": "Ouvert {type} match à {time} sur {court} , {count} places restantes",
  "member_reciprocal_access": "Accès réciproque",
  "member_booking_cancelled": "Réservation annulée",
  "member_visit_request_approved": "Demande de visite approuvée",
  "member_scheduled_class": "Catégorie prévue",
  "member_places_available_count": "Lieu disponible: {count}",
  "member_primary_member": "Membre principal",
  "member_hotel_reservation": "Hotels reservation",
  "member__sport_open_match": "{sport} · match ouvert",
  "member_facility_unavailable": "Installation non disponible",
  "member_book_tee_times": "Livre départs",
  "member_reserve_courts": "Courts de réserve",
  "member_book_spa_services": "Services de spa de réservation",
  "member_book_fitness_classes": "Cours de remise en forme",
  "member_booking_coming_soon": "Les réservations arrivent bientôt",
  "member_opening_secure_checkout": "Ouverture de la caisse sécurisée",
  "member_please_wait_while_we_prepare_your_payment": "Veuillez patienter pendant que nous préparons votre paiement.",
  "member_connecting_to_secure_checkout": "Se connecter pour sécuriser la caisse...",
  "member_your_member_portal_tab_will_stay_open": "Votre onglet portail membre restera ouvert.",
  "member_payment_received": "Paiement reçu",
  "member_thank_you_your_payment_is_processing": "Merci — votre paiement est le traitement.",
  "member_your_secure_checkout_has_completed_we_ll_update_your_account_as_soon_as_the_club_s_payment_confirmation_is_received": "Votre caisse sécurisée a terminé. Nous mettrons à jour votre compte dès que la confirmation de paiement du club sera reçue.",
  "member_no_payment_was_taken": "Aucun paiement n'a été pris.",
  "member_you_can_return_to_your_account_and_start_secure_checkout_again_whenever_you_are_ready": "Vous pouvez retourner à votre compte et commencer à sécuriser la commande à nouveau chaque fois que vous êtes prêt.",
  "member_payment_declined": "Le paiement a diminué",
  "member_your_payment_could_not_be_completed": "Votre paiement n'a pas pu être effectué.",
  "member_checkout_normally_shows_card_decline_messages_before_redirecting_this_page_is_here_if_the_club_sends_you_a_manual_declined_payment_link": "Le check-out affiche normalement des messages de carte-décline avant de rediriger. Cette page est ici si le club vous envoie un lien de remboursement manuel.",
  "member_secure_checkout_completed_in_stripe": "Paiement sécurisé terminé en Stripe .",
  "member_return_to_account": "Retour au compte",
  "member_returning_you_to_your_booking": "Rendez-vous à votre réservation...",
  "member_your_booking_is_confirmed_you_can_close_this_checkout_tab_and_continue_in_your_original_booking_tab": "Votre réservation est confirmée. Vous pouvez fermer cet onglet de commande et continuer dans votre onglet de réservation original.",
  "member_return_to_booking_confirmation": "Retour à la confirmation de réservation",
  "member_we_could_not_confirm_your_booking": "Nous ne pouvions pas confirmer votre réservation",
  "member_payment_was_received_but_we_could_not_confirm_the_booking_automatically_please_contact_the_club": "Le paiement a été reçu, mais nous ne pouvions pas confirmer la réservation automatiquement. Veuillez contacter le club.",
  "member_payment_was_received_but_the_booking_could_not_be_finalised_automatically_please_contact_the_club": "Le paiement a été reçu, mais la réservation ne pouvait pas être finalisée automatiquement. Veuillez contacter le club.",
  "member_still_confirming_your_payment_this_may_take_a_few_moments": "Encore en confirmant votre paiement, cela peut prendre quelques instants.",
  "member_confirming_your_payment": "Confirmer votre paiement...",
  "member_loading_secure_payment_link": "Chargement du lien de paiement sécurisé...",
  "member_payment_link_unavailable": "Lien de paiement non disponible",
  "member_this_guest_payment_token_is_invalid_or_expired": "Ce jeton de paiement est invalide ou expiré.",
  "member_privana_guest_payment": "Paiement invité Privana",
  "member_event_guest_ticket": "Billets d'invité",
  "member_date_time_tbc": "Date/heure TBC",
  "member_paid_online_thank_you": "Payé en ligne.",
  "member_pay_securely_with_privana_pay": "Payez en toute sécurité avec Privana Payez",
  "member_your_payment_succeeded_we_are_finalising_your_booking_now": "Votre paiement a réussi. Nous finalisons votre réservation maintenant."
}
